<template>
  <div class="question-contanier">
    <div class="question-detail">
      <Enable v-if="!meetingQaEnable" />
      <List v-else />
    </div>
  </div>
</template>

<script>
import Enable from "./enable";
import List from "./list";
export default {
  components: {
    List,
    Enable
  },
  computed: {
    meetingQaEnable() {
      return this.$store.getters.meetingQaEnable;
    },
    meetingIsStart() {
      return this.$store.getters.meetingIsStart;
    }
  }
};
</script>

<style lang="less">
.question-contanier {
  width: 1400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .question-detail {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    background-color: #ffffff;
    border: 1px solid #e3e7ed;
    border-radius: 0 4px 4px 4px;
  }
}
</style>
